module.exports = __webpack_public_path__ + "static/media/quip.6f8700ba.svg";